import * as React from "react";
import { forwardRef, memo } from "react";
const SvgStraighten = (props, ref) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M167.587-234.022q-39.433 0-67.216-27.783-27.784-27.784-27.784-67.217v-301.956q0-39.433 27.784-67.217t67.216-27.783h624.826q39.433 0 67.216 27.783 27.784 27.784 27.784 67.217v301.956q0 39.433-27.784 67.217t-67.216 27.783zm0-95h624.826v-301.956H694V-468h-84v-162.978h-84V-468h-84v-162.978h-84V-468h-84v-162.978H167.587zM274-468h84zm168 0h84zm168 0h84zm-130-12" })));
const ForwardRef = forwardRef(SvgStraighten);
const Memo = memo(ForwardRef);
export default Memo;
